import React from "react";

interface ContentSectionHeaderProps {
  title: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

const ContentSectionHeader: React.FC<ContentSectionHeaderProps> = ({
  title,
  actions,
  className = "",
}) => {
  return (
    <div
      className={`mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between ${className}`.trim()}
    >
      <div className="text-xl font-semibold text-[#0F172A] dark:text-gray-100">
        {title}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
};

export default ContentSectionHeader;
